/** RFC 4180 cell: quote when needed, double inner quotes. */
export function csvCell(value: string | number | null | undefined): string {
  const cell = value === null || value === undefined ? "" : String(value);
  return /[",\r\n]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell;
}

export type SheetRow = { material: string; sku: string; factoryProductId: string; factory: string; systemQty: string; uom: string };

/** The stock-take sheet: what the Pool tab shows, one row per material × factory, with an empty Counted column. */
export function stockTakeSheet(rows: SheetRow[]): string {
  const header = ["Material", "Xero code", "Factory Product ID", "Factory", "System qty", "UoM", "Counted"];
  const lines = [header.map(csvCell).join(",")];
  for (const row of rows) lines.push([row.material, row.sku, row.factoryProductId, row.factory, row.systemQty, row.uom, ""].map(csvCell).join(","));
  return `${lines.join("\r\n")}\r\n`;
}

export function sheetFilename(entity: string, asAt: string | null, today: string): string {
  return `stock-take-${entity}-${asAt ?? today}.csv`;
}
